import { render, staticRenderFns } from "./ExploreProjects.vue?vue&type=template&id=63c5f2ac&"
import script from "./ExploreProjects.vue?vue&type=script&lang=js&"
export * from "./ExploreProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports